<template>
	<div class="teamer">
		<div class="member-box">
			<ul class="member-list" v-if="members.length !== 0">
				<li v-for="(item, key) in members" :key="key">
					<div
						class="head"
						:style="{
							'background-image': `url(${item.avatar || defaultAvatar})`
						}"
					></div>
					<div class="name">
						<div class="label-box">
							<div class="label-shadow">{{ item.name ? item.name : '-' }}</div>
							<div class="label-text">{{ item.name ? item.name : '-' }}</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="data-box panel-data">
			<ul class="header panel-head">
				<li v-for="(item, key) in header" :key="key" :name="item.key">
					<div class="item">
						<div class="label-box">
							<span class="label-shadow">{{ item.name }}</span>
							<span class="label-text">{{ item.name }}</span>
						</div>
					</div>
				</li>
			</ul>
			<ul class="data-list">
				<li v-for="(member, key) in members" :key="key" class="panel-row">
					<ol>
						<li name="name">{{ member['name'] ? member['name'] : '-' }}</li>
						<li name="playerAvgKill">
							{{ formatNullValue(member['playerAvgKill']) }}
						</li>
						<li name="playerAvgAccuracy">
							{{ formatPercentage(formatNullValue(member['playerAvgAccuracy'])) }}
						</li>
						<li name="playerAvgDamage">
							{{ formatNullValue(member['playerAvgDamage']) }}
						</li>
						<li name="playerAvgSurvivalTime">
							{{ formatTime(formatNullValue(member['playerAvgSurviveTime'])) }}
						</li>
						<li name="playerAvgTravelDistance">
							{{ formatDistance(formatNullValue(member['playerAvgTravelDistance'])) }}
						</li>
						<li name="playerTotalKill">
							{{ formatNullValue(member['playerTotalKill']) }}
						</li>
					</ol>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps({
	subTeam: {
		type: Object,
		default: () => {}
	}
})

const route = useRoute()

// 默认头像: 队员未补齐 / 真实数据 avatar 为空时兜底
const defaultAvatar = 'https://website.xdcdn.net/poster/58881/26match/common/QT0Veunj.jpg'

const members = ref([])
const header = ref([
	{ key: 'name', name: '队员' },
	{ key: 'playerAvgKill', name: '场均淘汰' },
	{ key: 'playerAvgAccuracy', name: '命中率' },
	{ key: 'playerAvgDamage', name: '场均伤害' },
	{ key: 'playerAvgSurvivalTime', name: '场均存活' },
	{ key: 'playerAvgTravelDistance', name: '场均位移' },
	{ key: 'playerTotalKill', name: '淘汰总数' }
])

watch(
	() => props.subTeam,
	(newVal) => {
		getMembersInfo(newVal)
	},
	{ immediate: true, deep: true }
)

function formatNullValue(value) {
	return value || value === 0 ? Math.round(value) : '-'
}

function formatPercentage(value) {
	return value !== '-' ? `${value}%` : value
}

function formatTime(value) {
	return value !== '-' ? `${Math.floor(value / 60)}m${value % 60}s` : value
}

function formatDistance(value) {
	return value !== '-' ? `${(value / 1000).toFixed(2)}km` : value
}

function getMembersInfo(data = {}) {
	let subTeam = route.params.subTeam
	if (subTeam) {
		if (
			Object.keys(subTeam).length !== 0 &&
			subTeam.playerLists &&
			subTeam.playerLists.length !== 0
		) {
			members.value = subTeam.playerLists
		}
	} else {
		if (
			Object.keys(data).length !== 0 &&
			data.playerLists &&
			data.playerLists.length !== 0
		) {
			members.value = data.playerLists
		}
	}

	let memberLength = members.value.length;
	if(memberLength <= 5) {
		for(let i = 0; i < 5 - memberLength; i++) {
		members.value.push({
				avatar: defaultAvatar,
				name: '待补充成员'
			})
		}
	}

	// 埋点
	if (typeof tapdb === 'undefined') return
	tapdb.trackEvent('队员详情', {
		'#team_id': subTeam?.name
	})
}

onMounted(() => {
	getMembersInfo()
})
</script>

<style lang="scss" scoped>
@import "../../panels";

.teamer {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	.member-box {
		width: 100%;
		@include r(margin-bottom, 10);

		.member-list {
			width: 100%;
			@include r(height, 272);
			display: flex;
			justify-content: space-between;

			li {
				position: relative;
				flex-basis: 19.1%;
				background: url(https://website.xdcdn.net/poster/58881/26match/common/QTZo5uyk.png) center/100% 100% no-repeat;
        @include r_shadow(0, 4, 4, rgba(#000, 0.2));
				display: flex;
				flex-direction: column;
				align-items: center;

				.head {
					box-sizing: border-box;
					@include r(width, 194);
					@include r(height, 194);
					background-size: cover;
					background-repeat: no-repeat;
					background-position: center;
					@include r(border-radius, 11);
					border-style: solid;
					border-color: #fff;
					@include r(border-width, 3);
					@include r(margin-top, 13);
					@include r(margin-bottom, 24);
				}

				.name {
					@include r(font-size, 20);
					.label-box {
						.label-shadow {
							color: #fff;
						}
						.label-text {
							color: #333333;
						}
					}
				}

				&:first-child {
					&::before {
						content: '';
						position: absolute;
						@include r(width, 35);
						@include r(height, 38);
						@include r(left, 20);
						@include r(bottom, 8);
						background-image: url('https://website.xdcdn.net/module/sausage-match/images/clan/flag.png');
						background-position: center;
						background-repeat: no-repeat;
						background-size: contain;
					}
				}
			}
		}
	}

	.data-box {

		.header {
			width: 100%;
			justify-content: space-around;

			li {
				width: 10%;
				text-align: center;

				&[name="name"] {
					flex: 0 0 get_vh(140);
				}

				.item {
					display: inline-flex;
				}
			}
		}

		.data-list {
			width: 100%;
			flex: 1;
			overflow: hidden;

			display: flex;
			flex-direction: column;

			>li {
				flex: 1;

				ol {
					display: flex;
					justify-content: space-around;
					align-items: center;
					height: 100%;

					>li {
						width: 10%;
						text-align: center;

						&[name="name"] {
							flex: 0 0 get_vh(140);
							text-align: center;
							color: #333333;
						}
					}
				}
			}
		}
	}
}
</style>
